import OrganisationTypeEnum from '@constants/enums/organisation/type';
import UserRoleEnum from '@constants/enums/user/role';
import UserStatusEnum from '@constants/enums/user/status';

import i18n from '@plugins/i18n';

import { Collection, User } from '@/models';

export class SystemUsersCollection extends Collection {
    static type = 'SystemUsersCollection';
    static endpoint = User.api.index;
    static model = User;

    get default_headers() {
        return ['name', 'email', 'organisation_name', 'organisation_type', 'role', 'fca_number', 'status', 'control'];
    }

    get headers() {
        return [
            this.createHeader('id', i18n.t('id'), {
                classList: ['no-wrap'],
                width: '20rem',
                filterable: {
                    operators: this.getOperators(['eq'])
                }
            }),
            this.createHeader('name', i18n.t('name'), {
                width: '18rem',
                minWidth: '18rem',
                filterable: true
            }),
            this.createHeader('email', i18n.t('email'), {
                width: '15rem',
                filterable: true
            }),
            this.createHeader('organisation_name', i18n.t('organisation'), {
                path: 'organisation.name',
                width: '15rem',
                filterable: true
            }),
            this.createHeader('organisation_type', i18n.t('organisation_type'), {
                filterable: true,
                transform: data => data?.item?.organisation?.type,
                width: '11rem',
                format: 'enum',
                enum: OrganisationTypeEnum,
                enumA11yKey: 'enums.organisation_type'
            }),
            this.createHeader('role', i18n.t('role'), {
                format: 'enum',
                enum: UserRoleEnum,
                enumA11yKey: 'enums.user_role',
                multiple: true,
                width: '11rem',
                transform: data => {
                    const organisationId = data?.item?.organisation_id;
                    let roles = [];

                    if (data.item.roles) {
                        data.item.roles.forEach(role => {
                            if (organisationId && role.organisation_id !== organisationId) {
                                return;
                            }

                            roles.push(...role.roles);
                        });
                    }

                    return [...new Set([...roles])];
                }
            }),
            this.createHeader('fca_number', i18n.t('fca_number'), {
                filterable: true,
                width: '11rem'
            }),
            this.createHeader('status', i18n.t('status'), {
                filterable: true,
                width: '8rem',
                format: 'enum',
                enum: UserStatusEnum,
                enumA11yKey: 'enums.user_status',
                enumTypes: {
                    [UserStatusEnum.ACTIVE]: 'success',
                    [UserStatusEnum.INACTIVE]: 'grey',
                    [UserStatusEnum.SUSPENDED]: 'error',
                    [UserStatusEnum.UNVERIFIED]: 'warning'
                }
            }),
            this.createHeader('control', '', {
                format: 'control',
                width: '8rem',
                align: 'center'
            })
        ];
    }
}

export default SystemUsersCollection;
